export const SPECIAL_DAYS = {
  "2017-03-15": false,
  "2017-04-14": false,
  "2017-04-17": false,
  "2017-05-01": false,
  "2017-06-05": false,
  "2017-10-23": false,
  "2017-11-01": false,
  "2017-12-25": false,
  "2017-12-26": false,
  "2018-01-01": false,
  "2018-03-10": true,
  "2018-03-15": false,
  "2018-03-16": false,
  "2018-03-30": false,
  "2018-04-02": false,
  "2018-04-21": true,
  "2018-04-30": false,
  "2018-05-01": false,
  "2018-05-21": false,
  "2018-08-20": false,
  "2018-10-13": true,
  "2018-10-22": false,
  "2018-10-23": false,
  "2018-11-01": false,
  "2018-11-02": false,
  "2018-11-10": true,
  "2018-12-01": true,
  "2018-12-15": true,
  "2018-12-24": false,
  "2018-12-25": false,
  "2018-12-26": false,
  "2018-12-31": false,
  "2019-01-01": false,
  "2019-03-15": false,
  "2019-04-19": false,
  "2019-04-22": false,
  "2019-05-01": false,
  "2019-06-10": false,
  "2019-08-10": true,
  "2019-08-19": false,
  "2019-08-20": false,
  "2019-10-23": false,
  "2019-11-01": false,
  "2019-12-07": true,
  "2019-12-14": true,
  "2019-12-24": false,
  "2019-12-25": false,
  "2019-12-26": false,
  "2019-12-27": false,
  "2020-01-01": false,
  "2020-04-10": false,
  "2020-04-13": false,
  "2020-05-01": false,
  "2020-06-01": false,
  "2020-08-20": false,
  "2020-08-21": false,
  "2020-08-29": true,
  "2020-10-23": false,
  "2020-12-12": true,
  "2020-12-24": false,
  "2020-12-25": false,
  "2021-01-01": false,
  "2021-03-15": false,
  "2021-04-02": false,
  "2021-04-05": false,
  "2021-05-01": false,
  "2021-05-24": false,
  "2021-08-20": false,
  "2021-10-23": false,
  "2021-11-01": false,
  "2021-12-11": true,
  "2021-12-24": false,
  "2022-01-01": false,
  "2022-03-14": false,
  "2022-03-15": false,
  "2022-03-26": true,
  "2022-04-15": false,
  "2022-04-18": false,
  "2022-05-01": false,
  "2022-06-06": false,
  "2022-08-20": false,
  "2022-10-15": true,
  "2022-10-23": false,
  "2022-10-31": false,
  "2022-11-01": false,
  "2022-12-24": false,
  "2022-12-25": false,
  "2022-12-26": false,
  "2023-01-01": false,
  "2023-03-15": false,
  "2023-04-07": false,
  "2023-04-09": false,
  "2023-04-10": false,
  "2023-05-01": false,
  "2023-05-28": false,
  "2023-05-29": false,
  "2023-08-20": false,
  "2023-10-23": false,
  "2023-11-01": false,
  "2023-12-25": false,
  "2023-12-26": false,
  "2024-01-01": false,
  "2024-03-15": false,
  "2024-04-01": false,
  "2024-05-01": false,
  "2024-05-20": false,
  "2024-08-03": true,
  "2024-08-19": false,
  "2024-08-20": false,
  "2024-10-23": false,
  "2024-11-01": false,
  "2024-12-07": true,
  "2024-12-14": true,
  "2024-12-24": false,
  "2024-12-25": false,
  "2024-12-26": false,
  "2024-12-27": false,
  "2025-01-01": false,
  "2025-04-18": false,
  "2025-04-21": false,
  "2025-05-01": false,
  "2025-05-02": false,
  "2025-05-17": true,
  "2025-06-09": false,
  "2025-08-20": false,
  "2025-10-18": true,
  "2025-10-23": false,
  "2025-10-24": false,
  "2025-12-13": true,
  "2025-12-24": false,
  "2025-12-25": false,
  "2025-12-26": false,
  "2026-01-01": false,
  "2026-01-02": false,
  "2026-01-10": true,
  "2026-03-15": false,
  "2026-04-03": false,
  "2026-04-06": false,
  "2026-05-01": false,
  "2026-05-25": false,
  "2026-08-08": true,
  "2026-08-20": false,
  "2026-08-21": false,
  "2026-10-23": false,
  "2026-11-01": false,
  "2026-12-12": true,
  "2026-12-24": false,
  "2026-12-25": false,
  "2026-12-26": false,
};



//////////////////
// WEBPACK FOOTER
// ./src/js/specialDays.js
// module id = 18
// module chunks = 0